import { Button } from '@heroui/react'
import { Play } from 'lucide-react'
import { useSessionStorage } from 'usehooks-ts'

export default function PlayButton({ handleSelect }) {
  const [, setAutoplay] = useSessionStorage('autoplay', false)

  const handlePlay = () => {
    setAutoplay(true)
    handleSelect()
  }

  return (
    <Button variant="light" size="sm" radius="sm" color="primary" isIconOnly onPress={handlePlay}>
      <Play size={14} />
    </Button>
  )
}
